import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { t } = useLang();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = hash.includes("session_id=")
      ? hash.split("session_id=")[1].split("&")[0]
      : null;

    const run = async () => {
      try {
        if (sessionId) {
          await api.post("/auth/session", null, {
            headers: { "X-Session-ID": sessionId },
          });
          navigate("/admin", { replace: true });
          return;
        }
        navigate("/admin", { replace: true });
      } catch (e) {
        const denied = e?.response?.status === 403;
        navigate(denied ? "/admin?error=denied" : "/admin", { replace: true });
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
      {t("auth.authenticating")}
    </div>
  );
}
